import * as uuid from 'uuid';

import type { api } from 'common';
import { LlmModelName } from 'llm-model-registry';

function getDefaultInformationExtractionFieldConfig() {
  return {
    id: uuid.v4(),
    name: '',
    description: '',
  };
}

export function getDefaultInformationExtractionConfig(): api.FlowDefinition.InformationExtractionBlockConfig {
  return {
    documents: '',
    extractionFields: [getDefaultInformationExtractionFieldConfig()],
    examples: [],
    additionalPrompt: '',
    rankingPrompt: '',
    modelName: LlmModelName.notable_default,
  };
}
